const castTo = <T>(content: any) => JSON.parse(JSON.stringify(content)) as T;

const jsonHelper = { castTo };

export default jsonHelper;
